module.exports = __webpack_public_path__ + "static/media/cbn.60e6bc42.png";